

  const forms = document.querySelectorAll('.js-newsletter-signup');

  forms.forEach(form => {
    form.classList.add('init');
    form.addEventListener('submit', (e) => {
      e.preventDefault();
        const formData = new FormData(form);
        const data = Object.fromEntries(formData);
        console.log(data);
    });
  });

  